export enum LOGIN_FEATURES {
  LOGIN_METHOD = 'LOGIN_METHOD',
  LOGIN_FORM_TYPE = 'LOGIN_FORM_TYPE',
  SILENT_LOGIN = 'SILENT_LOGIN',
}

export enum LOGIN_METHOD {
  LOGIN_FORM = 'LOGIN_FORM',
  PIN_LOGIN = 'PIN_LOGIN',
  EXTERNAL_LOGIN = 'EXTERNAL_LOGIN',
}

export enum LOGIN_FORM_TYPE {
  SSO = 'SSO',
  OTT = 'OTT',
}

interface OAuthParams {
  code: string;
  redirectUri: string;
}

export interface FormParams {
  username: string;
  password: string;
}

export interface OAuthLoginParams {
  codeChallenge: string;
  codeVerifier: string;
  authUrl: string;
}

export interface UserLoginParams {
  form?: FormParams;
  oauth?: OAuthParams;
}
